import { render, staticRenderFns } from "./BisLogin.vue?vue&type=template&id=6d9a8720&scoped=true"
import script from "./BisLogin.vue?vue&type=script&lang=js"
export * from "./BisLogin.vue?vue&type=script&lang=js"
import style0 from "./BisLogin.vue?vue&type=style&index=0&id=6d9a8720&prod&lang=scss"
import style1 from "./BisLogin.vue?vue&type=style&index=1&id=6d9a8720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a8720",
  null
  
)

export default component.exports